<!-- =========================================================================================
  File Name: fournisseuractualites.vue
  Description: actualites Page
  ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
  <div id="actualites-clients">
    <div class="vx-row mb-2">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base h-full">
        <vx-card slot="no-body" class="text-center greet-user bg-primary">
          <feather-icon icon="AwardIcon" class="p-6 mb-12 inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-2 text-white">{{ getSalutation() }} {{ customerUserName }}</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"></p>
          <h1 class="mb-2 text-white">Bienvenue sur COGEPHA LIVE.</h1>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base">
        <div class="vx-row">
          <!-- CARD 2: SUBSCRIBERS GAINED -->
          <div class="vx-col w-full">
            <statistics-card-line :key="dataupdateKey" icon="DollarSignIcon" :statistic="totalNbreCommade" statisticTitle="Nombre Commade Par Portail" color="primary" type="area"></statistics-card-line>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base">
        <vx-card title="Evolution de nombre de commande par portail" @refresh="onChange()" class="">
          <div slot="no-body" class="mt-2">
            <evolution-nbre-commande />
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base h-full">
        <vx-card title=" " @refresh="onChange()" class="">
          <div slot="no-body" class="mt-2">
            <evolution-nbre-commande />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2">
        <vx-card title=" " class=""> </vx-card>
      </div>
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2">
        <vx-card title=" " class=""> </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import EvolutionNbreCommande from "@/views/adminportail/statistique/EvolutionNbreCommande.vue";
import adminServ from "@/http/requests/admin/index.js";
export default {
  name: "fourn-act",
  data() {
    return {
      totalNbreCommade: 0,
      dataupdateKey: 0,
      thisMonth: new Date().getMonth() + 1,
      thisYear: new Date().getFullYear(),
      periode: this.$store.state.article.analytcsdata.periode,
      selectedyear: this.$store.state.article.analytcsdata.selectedyear,
      checkpointReward: {
        userName: "",
        progress: "",
      },

      cogephaSelesSum: {
        Unbilled_returns: 0,

        Shipped_Not_Invoiced_LCY: 0,
      },
    };
  },
  computed: {
    currentClass: function () {
      return this.$store.state.article.analytcsdata.listData.length > 0 ? this.$store.state.article.analytcsdata.listData[this.$store.state.article.analytcsdata.listData.length - 1].Class : "";
    },
    customerUserName: function () {
      return this.$store.state.AppActiveUser.prenom != null ? this.$store.state.AppActiveUser.nom + " " + this.$store.state.AppActiveUser.prenom : this.$store.state.AppActiveUser.nom;
    },
  },
  methods: {
    //getSalutation(): change le mot bonjour suivant l'heure (supèrieure à 15h sera bonsoir)
    getSalutation() {
      var heures = new Date().getHours();
      console.log(heures);
      if (heures > 15) {
        return "BONSOIR";
      } else {
        return "BONJOUR";
      }
    },
    getNbreCommandeTotal() {
      adminServ.getNbreCommandePortailTotal().then((response) => {
        this.totalNbreCommade = response.data;
      });
    },
    onChangeyear(event) {
      this.selectedyear = event.target.value;

      this.$store.dispatch("article/UPDATE_PERIODE_YEAR", event.target.value);
    },
    onChangetrimestre(event) {
      this.periode = event.target.value;
      this.$store.dispatch("article/UPDATE_PERIODE", event.target.value);
    },
  },
  created() {
    if (this.$store.state.AppActiveUser.id != "") {
      this.getNbreCommandeTotal();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "UPDATE_USER_INFO") {
          this.getNbreCommandeTotal();
        }
      });
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    EvolutionNbreCommande,
  },
};
</script>

<style lang="scss">
#actualites-clients {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .rowHight {
    height: 35%;
  }

  .classDiamant {
    background-color: #b9f2ff;
  }

  .classPLATINUM {
    background-color: #e5e4e2;
  }

  .classGOLD {
    background-color: #ffd700;
  }

  .classSILVER {
    background-color: #c0c0c0;
  }

  .classBRONZE {
    background-color: #cd7f32;
  }

  .classEXPRESS {
    background-color: #ea00ff;
  }

  .classDORMANT {
    background-color: #ea5455;
  }

  .classDEFAULT {
    background-color: #e5e4e2;
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
